import { useChatPaneSelector, useChatScope } from '@/core/components/ChatPaneContext';
import { useChatAvailabilityQuery } from '@/core/components/useChatAvailabilityQuery';

/**
 * Availability remains unknown until the pane is restored; failed requests are unavailable.
 * `createChatPrompt` enforces authorization independently.
 */
export function useChatAvailability(): { hasScope: boolean; isChatDisabled: boolean | undefined } {
  const isReady = useChatPaneSelector(([value]) => value.isReady);
  const { hasScope, query } = useChatAvailabilityQuery(useChatScope());
  return {
    hasScope,
    isChatDisabled: query.isError ? true : isReady ? query.data?.isChatDisabled : undefined,
  };
}
